import React from 'react';
import styles from './MobileHeader.module.css';

export interface MobileHeaderProps {
  onMenuToggle: () => void;
  sidebarOpen: boolean;
}

const MobileHeader: React.FC<MobileHeaderProps> = ({ onMenuToggle }) => {
  return (
    <header className={styles.mobileHeader}>
      <button
        className={styles.hamburgerButton}
        onClick={onMenuToggle}
        title="Toggle menu"
        aria-label="Toggle navigation menu"
      >
        <span className={styles.hamburgerIcon}>
          <span></span>
          <span></span>
          <span></span>
        </span>
      </button>

      <div className={styles.headerTitle}>
        <h1>Business Account</h1>
      </div>
    </header>
  );
};

export default MobileHeader;
